<template>
  <div class="product-data">
    <Header/>
    <div class="content">
      <div class="label">
        <span>{{ $t('satellite.CurrentPosition') }}：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ $t('satellite.Home') }}</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/product' }">{{ $t('product.ProductData') }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ productBasiDetail.dataName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="padding-box">
        <p class="name">{{ productBasiDetail.dataName }}</p>
        <div class="date-num-level">
          <div class="date-num-level-box">
            <div class="label-site">
              <div class="logo">
                <span class="iconfont icon-shijian labels la1"></span>
              </div>
              <div class="label-text">
                <p>{{ fileUploadTime.fileUploadTime }}</p>
                <p>{{ $t('product.LastUpdateTime') }}</p>
              </div>
            </div>
            <div class="label-site">
              <div class="logo">
                <span class="iconfont icon-jurassic_data labels la2"></span>
              </div>
              <div class="label-text">
                <p>{{ byte2Auto(ProfileSpaceUsage.fileSpaceUsage) }}</p>
                <p>{{ $t('product.Datavolume') }}</p>
              </div>
            </div>
            <div class="label-site">
              <div class="logo">
                <span class="iconfont icon-zhibiao labels la3"></span>
              </div>
              <div class="label-text">
                <p>{{ productBasiDetail.dataGlanced }}<span>{{ $t('home.freq') }}</span></p>
                <p>{{ $t('product.DataAccessVolume') }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="info-box">
          <div class="left">
            <div class="layout-box">
              <div class="basic-info" :class="isEnglish?'basic-info-en':''">
                <p class="bl-title">{{ $t('product.BasicInfo') }}</p>
                <hr>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('product.Datatime') }}：</div>
                  <div class="basic-info-value" v-if="!isEnglish">
                    {{
                      ProfileCreateTime.fileCreateTime ? ProfileCreateTime.fileCreateTime.substr(0, 10) : '未知'
                    }}至{{
                      ProfileCreateTime.fileCreateTimeEnd ? ProfileCreateTime.fileCreateTimeEnd.substr(0, 10) : '未知'
                    }}
                  </div>
                  <div class="basic-info-value" v-else>
                    {{ ProfileCreateTime.fileCreateTime ? ProfileCreateTime.fileCreateTime.substr(0, 10) : '未知' }} To
                    {{ ProfileCreateTime.fileCreateTimeEnd ? ProfileCreateTime.fileCreateTimeEnd.substr(0, 10) : '未知' }}
                  </div>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('product.SpaceLocation') }}：</div>
                  <div class="basic-info-value">{{ productBasiDetail.dataLocation }}</div>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('product.Subject') }}：</div>
                  <div class="basic-info-value">{{ productBasiDetail.dataTags }}</div>
                </div>
                <!-- <div class="basic-info-site">
                    <div class="basic-info-title">学科类别：</div>
                    <span class="basic-info-value">{{productBasiDetail.dataSubjectTypeName}}</span>
                </div> -->
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('DataSubmission.ProductCategory') }}：</div>
                  <div class="basic-info-value">{{ productBasiDetail.dataTypeName }}</div>
                </div>
                <div class="basic-info-site">
                  <div class="basic-info-title">{{ $t('product.SharingLevel') }}：</div>
                  <div class="basic-info-value">{{ productBasiDetail.dataShareLevelName }}</div>
                </div>
              </div>
              <div class="connect" :class="isEnglish?'connect-en':''">
                <p class="bl-title">{{ $t('product.DataContactInfo') }}</p>
                <hr>
                <div class="connect-site">
                  <div class="connect-title">{{ $t('product.Contact') }}：</div>
                  <div class="connect-value">{{ productContact.name }}</div>
                </div>
                <div class="connect-site">
                  <div class="connect-title">{{ $t('product.Phone') }}：</div>
                  <div class="connect-value">{{ productContact.phone }}</div>
                </div>
                <div class="connect-site">
                  <div class="connect-title">{{ $t('product.Mail') }}：</div>
                  <div class="connect-value">{{ productContact.email }}</div>
                </div>
                <div class="connect-site">
                  <div class="connect-title">{{ $t('product.Institution') }}：</div>
                  <div class="connect-value">{{ productContact.organizational }}</div>
                </div>
                <div class="connect-site">
                  <div class="connect-title">{{ $t('product.Address') }}：</div>
                  <div class="connect-value">{{ productContact.address }}</div>
                </div>
              </div>
            </div>
            <div class="get-data">
              <p class="bl-title">{{ $t('product.DataAcquisitionMethod') }}</p>
              <hr>
              <div class="time-line">
                <div class="line-site" v-for="(i,index) in getDataMethods" :key="i.index">
                  <div class="circle center">
                    <span style="z-index:3">{{ index + 1 }}</span>
                    <div class="line" v-if="index!=2"></div>
                  </div>
                  <p>{{ $t(`product.${i}`) }}</p>
                </div>
              </div>
              <div class="date-tools">
                <!-- <div class="sub-collect center" @click="cunApplicationShow = true">运行申请</div> -->
                <div class="sub-collect center" @click="subData" v-if="subStatus">{{
                    $t('product.SubscribetoData')
                  }}
                </div>
                <div class="sub-collect center" v-else>{{ $t('product.subscribed') }}</div>
                <div class="sub-collect center" @click="collectData" v-if="collectStatus">{{
                    $t('product.Favoritedata')
                  }}
                </div>
                <div class="sub-collect center" v-else>{{ $t('product.Collected') }}</div>
                <div class="add center" @click="addAllFileToCar">{{ $t('product.AddDataOrder') }}</div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="product-image">
              <img
                  style="width: 100%; height: 100%;border: 0px"
                  :src="mediaDown+productBasiDetail.mediaUrl"/>
            </div>
            <div class="map-L" id="mapL" v-if="queryInfoDetail.showFlag">
              <div class="mask"></div>
              <div class="view-animation center" style="right:150px;" v-if="isShowGame" @click="openGameVideo">
                <span class="iconfont icon-bofang" style="margin-right:4px;"></span>
                {{ $t('product.GameEngineEffects') }}
              </div>
              <div class="view-animation center" @click="openDialog()">
                <span class="iconfont icon-bofang" style="margin-right:4px;"></span>
                {{ $t('product.ClicktoView') }}
              </div>
              <BaseInitMap v-if="areaRangeLoading&&ImageServerLoading" :areaBox="areaRange"
                           :collections="imageServiceCollections"/>
            </div>
          </div>
        </div>
        <div class="summary">
          <p class="bl-title"> {{ $t('product.DataSummary') }}</p>
          <hr>
          <p class="summary-content">{{ productBasiDetail.dataDesc }}</p>
        </div>
        <!-- <div class="annex">
            <p class="bl-title">数据附件</p>
            <hr>
            <p class="an-content a1">数据说明文档：</p>
            <p class="an-content" v-for="i in ProductAppendixList1" :key="i.index">{{i.fileName}} <span class="down" v-if="i.filePath" @click="down(i.filePath)">{{ $t('product.download') }}</span></p>
            <p class="an-content a1">数据样例：</p>
            <p class="an-content" v-for="i in ProductAppendixList2" :key="i.index">{{i.fileName}} <span class="down" v-if="i.filePath" @click="down(i.filePath)">{{ $t('product.download') }}</span></p>
        </div> -->
        <div class="use-info">
          <p class="bl-title">{{ $t('product.DataUsageInformation') }}</p>
          <hr>
          <p class="use-content u1">{{ $t('product.AcknowledgementFormat') }}：</p>
          <p class="use-content">{{ $t('product.AcknowledgmentRefertotheFollowingSpecifications') }}：</p>
          <p class="use-content">{{ $t('product.AcknowledgmentinChinese') }}：{{ $t('product.p1') }}</p>
          <p class="use-content">{{ $t('product.AcknowledgementinEnglish') }}: Acknowledgement for the data support from
            Southern Marine Science and Engineering Guangdong Laboratory (Zhuhai).</p>
          <p class="use-content u1">{{ $t('product.Attention') }}</p>
          <p class="use-content">{{ $t('product.p2') }}</p>
          <p class="use-content">{{ $t('product.p3') }}</p>
          <p class="use-content">{{ $t('product.p4') }}</p>
          <p class="use-content u1">{{ $t('product.RelevantLiterature') }}：</p>
          <!-- <p class="use-content">无</p> -->
          <p class="use-content" style="color: rgba(38,125,255,1);cursor:pointer;" @click="viewPdf(i.mediaUrl)"
             v-for="i in ProductAppendixList3" :key="i.index">{{ i.fileName }}</p>

        </div>
        <div class="important-hint">
          <p class="bl-title" style="font-size:15px;color:#8A9FB9;">*{{ $t('product.p5') }}</p>
          <p class="bl-title" style="font-size:15px;color:#8A9FB9;">*{{ $t('product.p6') }}</p>
          <p class="bl-title" style="font-size:15px;color:#8A9FB9;">*{{ $t('product.p7') }}</p>
        </div>

      </div>
      <div class="table-data">
        <div class="left">
          <div>
            <div class="centerS">
              <span class="bl-title">{{ $t('product.DataFile') }}</span>
              <div class="center">
                <el-date-picker
                    v-model="productFileQueryTime.start"
                    type="date"
                    size="mini"
                    class="time-color"
                    value-format="yyyy-MM-dd"
                    :placeholder="$t('satellite.Start')">
                </el-date-picker>
                <div style="margin:  0 10px;color: gray">-</div>
                <el-date-picker
                    v-model="productFileQueryTime.end"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="mini"
                    class="time-color"
                    :placeholder="$t('satellite.End')">
                </el-date-picker>
                <el-button size="mini" @click="changeProductFileQueryTime" style="margin:0 0 0 12px">
                  {{ $t('Order.query') }}
                </el-button>
                <el-button size="mini" @click="clearProTime">{{ $t('product.clean') }}</el-button>
              </div>
            </div>
            <hr>
            <div class="tables">
              <div class="tables-header">
                <div class="t1"></div>
                <div class="t2">
                  {{ $t('product.DataFileName') }}
                </div>
                <div class="t3">{{ $t('product.FileType') }}</div>
                <div class="t4">{{ $t('product.FileSize') }}</div>
                <div class="t5">{{ $t('product.Createdtime') }}</div>
                <div class="t6 center">{{ $t('product.Operation') }}</div>
              </div>
              <div class="tables-body main-box" v-if="productFileList&&productFileList.length!=0">
                <div class="body-site" v-for="i in productFileList" :key="i.index">
                  <div class="t1">
                    <el-checkbox v-model="i.selectStatus"></el-checkbox>
                  </div>
                  <div class="t2" :title="i.fileName">
                    <span>
                      {{ i.fileName }}
                    </span>
                  </div>
                  <div class="t3" style="padding-left:20px;width:100px;" :title="i.fileSuffix">
                    <span style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">{{
                        i.fileSuffix
                      }}</span>
                  </div>
                  <div class="t4">{{ byte2Auto(i.fileSpaceUsage) }}</div>
                  <div class="t5">{{ i.createTime }}</div>
                  <div class="t6">
                    <span class="iconfont icon-gouwucheman" style="color:#267dff;cursor:pointer;"
                          @click="addSingleFileToCar(i.pkid)"></span>
                  </div>
                </div>
              </div>
              <div v-else class="tables-body main-box">
                <div class="body-site">
                  <div class="t1">
                    {{ $t('product.Empty') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="tools-box">
            <div class="center">
              <div class="check center">
                <el-checkbox v-model="allSelect" @change="selectAllProduct"></el-checkbox>
              </div>
              <el-button size="mini" class="batch" type="primary" :disabled="productFileList.length===0"
                         @click="addSelectFilesToCar">{{
                  $t('product.AddtoCartinBulk')
                }}
              </el-button>
              <el-badge :value="shopTotal_getter" class="item" type="primary" style="margin-left:12px;">
                <el-button size="mini" @click="$router.push({name:'shopcar'})">
                  {{ $t('product.shoppingCar') }}
                </el-button>
              </el-badge>
            </div>
            <el-pagination
                background
                @current-change="currentChange"
                :pager-count="5"
                layout="prev, pager, next"
                :total="productFileListTotal">
            </el-pagination>
          </div>
        </div>
        <div class="right">
          <div class="top">
            <p class="bl-title">{{ $t('product.DownloadedUser') }}</p>
            <hr>
            <div class="tables-user">
              <div class="tables-user-header">
                <div class="t1 center">{{ $t('product.UserName') }}</div>
                <div class="t2 center">
                  {{ $t('product.Institution') }}
                </div>
                <div class="t4 center">{{ $t('product.Time') }}</div>
              </div>
              <div class="tables-user-body main-box" v-if="UserDown&&UserDown.length!=0">
                <div class="body-site" v-for="i in UserDown" :key="i.index">
                  <div class="t1 center">
                    {{ i.userName }}
                  </div>
                  <div class="t2 center" :title="i.organizational">
                    <span>
                        {{ i.organizational }}
                    </span>
                  </div>
                  <div class="t4 center">{{ i.createDate.split(' ')[0] }}</div>
                </div>
              </div>
              <div v-else class="tables-user-body main-box">
                <div class="body-site">
                  <div class="t1 center">
                    {{ $t('product.Empty') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom">
            <p class="bl-title">{{ $t('product.LatestViewData') }}</p>
            <div class="tables-browse">
              <div class="tables-browse-body main-box" v-if="UserFootList&&UserFootList.length!=0">
                <div class="body-site" v-for="i in UserFootList" :key="i.index">
                  <div class="t1 center">
                    {{ i.dataName }}
                  </div>
                </div>
              </div>
              <div v-else class="tables-browse-body main-box">
                <div class="body-site">
                  <div class="t1 center">
                    {{ $t('product.Empty') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
        :title="$t('product.warning')"
        :visible.sync="centerDialogVisible"
        width="96%"
        :fullscreen="fullMap"
        :destroy-on-close="true"
        custom-class="map-dialog"
        top="36px"
        center>
      <!-- calc(100vh - 72px) -->
      <div class="productMap" style="height:892px;" id="htmlToImage">
        <div class="top-name">
          <span>{{ productBasiDetail.dataName }}</span>
          <div class="center">
            <img src="@/assets/image/product-detail-dialog/logo1.png" alt="">
            <img src="@/assets/image/product-detail-dialog/logo2.png" alt="">
          </div>
        </div>
        <div class="bottom-content">
          <div class="left-info">
            <div class="info-title">
              {{ $t('product.ProductOverview') }}
            </div>
            <div class="overview-info">
              <img class="info-img" :src="mediaDown+dialogInfo.rImg" alt="">
              <div class="p1 main-box">
                {{ dialogInfo.le1 }}
              </div>
            </div>
            <div class="info-title" style="margin-top: 21px;">
              {{ $t('product.MetadataInfo') }}
            </div>
            <div class="mete-data main-box">
              <div class="site-icon">
                <p class="in">{{ $t('product.DataType') }}：{{ dialogInfo.le2.lx }}</p>
                <p class="in">{{ $t('product.SpatialResolution') }}：{{ dialogInfo.le2.kjfbl }}</p>
                <p class="in">{{
                    $t('product.TemporalResolution')
                  }}：{{ dialogInfo.le2.sjfbl }}{{ timeUnit(dialogInfo.le2.sjfblunit) }}</p>
                <p class="in">{{ $t('product.SpatialPosition') }}：{{ dialogInfo.le2.kjwz }}</p>
                <p class="in">{{ $t('product.Datatimerange') }}：{{ dialogInfo.le2.sjsj }}</p>
              </div>
              <div class="site-icon">
                <div class="tt">
                  {{ $t('product.SourceDataofProduct') }}：
                </div>
                <div>
                  <p class="in" v-for="(i,index) in dialogInfo.le3" :key="i.index">{{ index + 1 }}、{{ i }}</p>
                </div>
              </div>
            </div>
            <div class="info-title" style="margin-top: 21px;">
              {{ $t('product.Websites') }}
            </div>
            <div class="related-web">
              <!-- <p class="info">Two-Decade Variability of Sea Surface Temperature and Chlorophyll-a in the Northern South China Sea as Revealed by Reconstructed Cloud-Free Satellite Data</p> -->
              <p class="url" style="cursor:pointer;" @click="viewPdf(i.mediaUrl)" v-for="i in ProductAppendixList3"
                 :key="i.index">{{ i.fileName }}</p>
            </div>
          </div>
          <div class="center-map">
            <div class="time-play" v-if="imageServiceCollections[0].iserverImageType=='0'">
              <img v-if="palyStatus" @click="startPlay" class="t" src="@/assets/image/product-detail-dialog/bofang.png"
                   alt="">
              <img v-else class="t" @click="palyStatus=true" src="@/assets/image/product-detail-dialog/zanting.png"
                   alt="">
              <div class="time-r">
                <div class="time-site center" style="margin-right:8px;">
                  <span>{{ timeRnage.startTime }}</span>
                  <img src="@/assets/image/product-view-dialog/xiala.png" alt="">
                  <el-date-picker
                      type="date"
                      v-model="timeRnage.startTime"
                      class="time-picks"
                      size="mini"
                      :clearable='false'
                      value-format="yyyy-MM-dd"
                      placeholder="选择日期">
                  </el-date-picker>
                </div>
                <div class="time-site center">
                  <span>{{ timeRnage.endTime }}</span>
                  <img src="@/assets/image/product-view-dialog/xiala.png" alt="">
                  <el-date-picker
                      type="date"
                      v-model="timeRnage.endTime"
                      class="time-picks"
                      value-format="yyyy-MM-dd"
                      size="mini"
                      :clearable='false'
                      :placeholder="$t('product.optiondate')">
                  </el-date-picker>
                </div>
              </div>
            </div>
            <div class="top-tool">
              <div style="overflow: hidden;position: relative;margin-right: 5px;">
                <div class="tool-l" :class="isShow?'':'active'">
                  <div class="arrow" @click="isShow = !isShow"></div>
                  <el-dropdown @command="measureLength" class="center">
                    <div class="center">
                      <img src="@/assets/image/product-detail-dialog/测距.png" alt="">
                      <span class="tool-p">{{ $t('product.DistanceMeasurement') }}</span>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item command="g">{{ $t('cloudComputing.kilometre') }}</el-dropdown-item>
                      <el-dropdown-item command="y">{{ $t('cloudComputing.statutemile') }}</el-dropdown-item>
                      <el-dropdown-item command="h">{{ $t('cloudComputing.nauticalmile') }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                  <img src="@/assets/image/product-detail-dialog/测面.png" @click="cemian" alt=""
                       :title="$t('product.AreaMeasurement')">
                  <span style="cursor: pointer" @click="cemian">{{ $t('product.AreaMeasurement') }}</span>
                  <img src="@/assets/image/product-detail-dialog/查询数值.png" @click="drawMarker" alt=""
                       :title="$t('product.Queryvalue')">
                  <span style="cursor: pointer" @click="drawMarker">{{ $t('product.Queryvalue') }}</span>
                  <img src="@/assets/image/product-detail-dialog/截图.png" alt="" :title="$t('product.Screenshot')"
                       @click="toImage">
                  <span style="cursor: pointer" @click="toImage">{{ $t('product.Screenshot') }}</span>
                  <img src="@/assets/image/product-detail-dialog/录屏.png" alt="" :title="$t('product.Recordscreen')"
                       @click="contalScreen">
                  <span style="cursor: pointer" @click="contalScreen">{{ $t('product.Recordscreen') }}</span>
                  <img src="@/assets/image/product-view-dialog/清除.png" @click="cancelDraw" alt=""
                       :title="$t('product.Clear')">
                  <span style="cursor: pointer" @click="cancelDraw">{{ $t('product.Clear') }}</span>
                  <img src="@/assets/image/product-detail-dialog/退出全屏.png" alt="" :title="$t('product.Fullscreen')"
                       @click="fullS">
                  <span style="cursor: pointer" @click="fullS">{{ $t('product.Fullscreen') }}</span>
                </div>
              </div>

              <div v-if="isShow3DBtn">
                <div v-if="show2d" class="tool-r center tool-p" @click="show2d=false" style="padding:0 5px;">
                  <img src="@/assets/image/product-detail-dialog/地图模式.png" alt="" :title="$t('product.map2d')">
                  {{ $t('cloudComputing.Mapmode') }}
                </div>
                <div v-else class="tool-r center tool-p" @click="show2d=true" style="padding:0 5px;">
                  <img src="@/assets/image/product-detail-dialog/3D模式.png" alt="" :title="$t('product.map3d')">
                  {{ $t('cloudComputing.Earthmode') }}
                </div>
              </div>
            </div>
            <div class="legend-my">
              <p class="unit" v-show="queryInfoDetail.ribbonType==='0'">{{
                  $t('product.unit')
                }}：{{ queryInfoDetail.productRibbonUnit }}</p>
              <p class="unit" v-show="queryInfoDetail.ribbonType==='1'" style="top:-18px">{{
                  $t('product.unit')
                }}：{{ queryInfoDetail.productRibbonUnit }}</p>
              <div class="top-line" v-show="queryInfoDetail.ribbonType==='0'">
                <canvas id="legendDe" class="legend-show l1"></canvas>
                <div class="right r1">
                  <p>{{ queryInfoDetail.endValue }}</p>
                  <p>{{ queryInfoDetail.startValue }}</p>
                </div>
              </div>
              <div class="top-line fenduan" v-show="queryInfoDetail.ribbonType==='1'">
                <div style="display:flex;margin:0 3px;"
                     v-for="(line,lineIndex) in Math.ceil(queryInfoDetail.principalValue.split(',').length/10)"
                     :key="line.index">
                  <div class="legend-fenduan-show l1"
                       :style="{height:queryInfoDetail.principalValue.split(',').length>10?10*28+'px':queryInfoDetail.principalValue.split(',').length*28+'px'}">
                    <div class="fen-duan-site"
                         :style="{background:queryInfoDetail.principalValue.split(',')[index+lineIndex*10]}"
                         v-for="(i,index) in queryInfoDetail.ribbonType==='1'?queryInfoDetail.principalValue.split(',').length>10?10:queryInfoDetail.principalValue.split(',').length:[]"
                         :key="i.index">
                    </div>
                  </div>
                  <div class="legend-fenduan-show2">
                    <div class="fen-duan-site"
                         v-for="(i,index) in queryInfoDetail.ribbonType==='1'?queryInfoDetail.principalValue.split(',').length>10?10:queryInfoDetail.principalValue.split(',').length:[]"
                         :key="i.index">
                      {{
                        queryInfoDetail.ribbonType === '1' ? queryInfoDetail.typeName.split(',')[index + lineIndex * 10] : ''
                      }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 镶嵌数据集展示 -->
            <div class="main-map-wh" v-if="imageServiceCollections[0].iserverImageType=='11'">
              <InitMapShowXQ ref="InitMapShow" :legendObj="legendObj" :url="imageServiceUrl"
                             :collections="imageServiceCollections" initId="product" v-if="centerDialogVisible&&!show2d"
                             :is2d="show2d" :timeRange="PlayTimeRange" :isplay="palyStatus"/>
              <CesiumMapShowXQ ref="CesiumMapShow" :legendObj="legendObj" :url="imageServiceUrl"
                               :collections="imageServiceCollections" initId="map-3d" v-if="centerDialogVisible&&show2d"
                               :is2d="show2d" :timeRange="PlayTimeRange" :isplay="palyStatus"/>
            </div>
            <!-- 影像服务展示 -->
            <div class="main-map-wh" v-if="imageServiceCollections[0].iserverImageType==='0'">
              <InitMapImage :dataSearchLatLng='dataSearchLatLng' @stopAnimate="stopAnimate"
                            :simpleName="dialogInfo.simpleName" :coordinates="dialogInfo.coordinates"
                            :productUnit="dialogInfo.productRibbonUnit" @searchHistoryData="searchHistoryData"
                            ref="InitMapShow" :dataQuery="dataQuery" :timeResolutionUnit="dialogInfo.timeResolutionUnit"
                            :legendObj="legendObj" :url="imageServiceUrl" :collections="imageServiceCollections"
                            initId="product" v-if="centerDialogVisible&&!show2d" :is2d="show2d"
                            :timeRange="PlayTimeRange" :isplay="palyStatus"/>
              <CesiumImage :dataSearchLatLng='dataSearchLatLng' @stopAnimate="stopAnimate"
                           :simpleName="dialogInfo.simpleName" :coordinates="dialogInfo.coordinates"
                           :productUnit="dialogInfo.productRibbonUnit" @searchHistoryData="searchHistoryData"
                           ref="CesiumMapShow" :dataQuery="dataQuery"
                           :timeResolutionUnit="dialogInfo.timeResolutionUnit" :legendObj="legendObj"
                           :url="imageServiceUrl" :collections="imageServiceCollections" initId="map-3d"
                           v-if="centerDialogVisible&&show2d" :is2d="show2d" :timeRange="PlayTimeRange"
                           :isplay="palyStatus"/>
            </div>
            <div class="main-map-wh" v-if="imageServiceCollections[0].iserverImageType==='3'">
              <CesiumS3m @stopAnimate="stopAnimate" :simpleName="dialogInfo.simpleName"
                         :coordinates="dialogInfo.coordinates" :productUnit="dialogInfo.productRibbonUnit"
                         @searchHistoryData="searchHistoryData" ref="CesiumMapShow" :dataQuery="dataQuery"
                         :timeResolutionUnit="dialogInfo.timeResolutionUnit" :legendObj="legendObj"
                         :url="imageServiceUrl" :collections="imageServiceCollections" initId="map-3d"
                         v-if="centerDialogVisible" :is2d="show2d" :timeRange="PlayTimeRange" :isplay="palyStatus"/>
            </div>
            <!-- 普通地图服务展示 -->
            <div class="main-map-wh" v-if="imageServiceCollections[0].iserverImageType==='2'">
              <InitMapDT ref="InitMapShow" :productFileList="productFileList" :simpleName="dialogInfo.simpleName"
                         :coordinates="dialogInfo.coordinates"
                         :legendObj="legendObj" :url="imageServiceUrl" :collections="imageServiceCollections"
                         initId="product" v-if="centerDialogVisible&&!show2d" :is2d="show2d" :timeRange="PlayTimeRange"
                         :isplay="palyStatus"/>
              <CesiumMapDT ref="CesiumMapShow" :productFileList="productFileList" :simpleName="dialogInfo.simpleName"
                           :coordinates="dialogInfo.coordinates"
                           :legendObj="legendObj" :url="imageServiceUrl" :collections="imageServiceCollections"
                           initId="map-3d" v-if="centerDialogVisible&&show2d" :is2d="show2d" :timeRange="PlayTimeRange"
                           :isplay="palyStatus"/>
            </div>
          </div>
          <div class="right-info">
            <div class="info-title">
              {{ $t('product.Introduction') }}
            </div>
            <div class="Introduction-info">
              <img class="info-img" :src="mediaDown+dialogInfo.leImg" alt="">
              <div class="cc1 main-box">
                {{ dialogInfo.r1 }}
              </div>
            </div>
            <div class="info-title" style="margin-top: 21px;">
              {{ $t('product.DynamicAnalysis') }}
            </div>
            <div class="dynamic-data-analyze">
              <p class="if">X:{{ dataSearchLatLng.lng }} Y:{{ dataSearchLatLng.lat }}</p>
              <p class="if">
                <span>{{
                    $t('product.Maximum')
                  }}:{{ rightDynamic.computedObj.max.value }}  {{ dialogInfo.productRibbonUnit }} </span>
                <span>{{
                    $t('product.Average')
                  }}:{{ rightDynamic.computedObj.ave }} {{ dialogInfo.productRibbonUnit }}</span>
              </p>
              <p class="if">
                <span>{{
                    $t('product.Minimum')
                  }}:{{ rightDynamic.computedObj.min.value }} {{ dialogInfo.productRibbonUnit }}</span>
                <span>{{
                    $t('product.StandardDeviation')
                  }}:{{ rightDynamic.computedObj.sta }} {{ dialogInfo.productRibbonUnit }}</span>
              </p>
              <p class="t-v">{{ $t('product.Time') }}/{{ $t('product.Value') }}:</p>
              <table>
                <thead>
                <tr>
                  <th style="width:92px;">{{ $t('product.Time') }}</th>
                  <th>{{ $t('product.Value') }}</th>
                  <th style="width:92px;">{{ $t('product.Time') }}</th>
                  <th>{{ $t('product.Value') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="i in rightDynamic.tableList" :key="i.index">
                  <td style="width:92px;font-size:10px;">{{ i[0] ? i[0] : '' }}</td>
                  <td style="font-size:10px;">{{ i[1] }}</td>
                  <td style="width:92px;font-size:10px;">{{ i[2] ? i[2] : '' }}</td>
                  <td style="font-size:10px;">{{ i[3] }}</td>
                </tr>
                </tbody>
              </table>
              <!-- <div class="right-echart2" id="rightE2"></div> -->
            </div>

          </div>
        </div>
        <p class="map-source">{{ $t('cloudComputing.Mapsource') }}：{{ $t('cloudComputing.Tianditu') }}</p>
      </div>
    </el-dialog>
    <Footer/>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import 'leaflet/dist/leaflet.css'
import axios from '@/utils/axios.min'
import L from 'leaflet'
import {tiledMapLayer} from '@supermap/iclient-leaflet'

import Header from "@/components/Header"
import Footer from "@/components/Footer"
import BaseInitMap from "./initMap"
import html2canvas from "html2canvas"

//产品展示
import CesiumMapShowXQ from "./productShow/CesiumMapYXmap.vue"
import InitMapShowXQ from "./productShow/initMapYXmap.vue"

import CesiumImage from "./productShow/CesiumImage.vue"
import CesiumS3m from "./productShow/CesiumS3m.vue"
import InitMapImage from "./productShow/initMapImage.vue"

import CesiumMapDT from "./productShow/CesiumMapDT.vue"
import InitMapDT from "./productShow/initMapDT.vue"

import {
  getProductDetail,
  getProductLevel,
  getProductContact,
  getProductFile,
  getProductAppendix,
  getProductBrowse,
  getProductUpdateTime,
  getProductDetailTime,
  getProductImageServiceInfo,
  getProductFileSize,
  getUserDown,
  addProductAllFileToCar,
  addCarForProduct,
  getSatelliteFileData,
  ApplyForRun,
  getRunRecord,
  ApplyRunOrder,
  addSubscribe,
  queryProductInfo,
  getXQDataOption,
  queryCoordinates,
  getSubscribeList,
  addCollect,
  getCollectList,
} from "@/api/product/index"
import ScreenRe from "@/utils/screenRe"
import {mapGetters} from "vuex";

import FullScreen from "@/utils/fullScreen"
import {colorpicks} from "@/utils/common"

export default {
  name: 'product-data',
  components: {
    Header,
    Footer,
    BaseInitMap,
    CesiumMapShowXQ,
    InitMapShowXQ,
    CesiumImage,
    CesiumS3m,
    InitMapImage,
    CesiumMapDT,
    InitMapDT,
  },
  data() {
    return {
      isShow: true,
      isEnglish: false,
      collectStatus: true,
      handlerMarker: null,
      tableList: [],
      dataSearchLatLng: {
        lat: 0,
        lng: 0
      },
      computedObj: {
        max: {},
        min: {},
        ave: '',
        sta: ''
      },
      timeRnage: {
        startTime: '2021-02-15',
        endTime: '2022-01-25'
      },
      rightDynamic: {
        computedObj: {
          max: {
            time: '0',
            value: '0'
          },
          min: {
            time: '0',
            value: '0'
          },
          ave: '0',
          sta: '0'
        },
        tableList: [
          ["", ""],
          // ["",""],
          // ["",""],
          // ["",""],
          // ["",""],
          // ["",""],
          // ["",""],
          // ["",""],
          // ["",""],
          // ["",""],
          // ["",""],
          // ["",""],
        ]
      },
      fullscreenClass: {},
      fullscreen: false,
      ScreenReC: null,
      disabled: {
        start: false,
        stop: true,
        download: true
      },
      dialogInfo: {
        le1: '',
        leImg: '',
        le3: [],
        le2: {},
        rImg: '',
        r1: '',
        totalProductDownVOS: {},
        timeResolutionUnit: "",
        productRibbonUnit: '',
        simpleName: "",
        coordinates: ''
      },
      viewRecordPkid: '',
      areaRange: [],
      areaRangeLoading: false,
      viewRecordDialog: false,
      tableData: [],
      product2MapGroup: null,
      stopRectArea: null,
      drawDataMap: [],
      product2MapDrawGroup: null,
      product2Map: null,
      PlayTimeRange: {
        start: '',
        end: ''
      },
      allSelect: false,
      feilType: [
        {
          pkid: "1463771955055300609",
          dicId: "1463771098767167489",
          dicItemCode: "PRODECT_DATA_FILE_TYPE_SJSMWD",
          dicItemName: "数据说明文档",
          dicItemOrder: "0",
          dicItemDesc: "产品数据文件类型-数据说明文档",
          createTime: "2021-11-24 08:00:00"
        },
        {
          pkid: "1463772062400122881",
          dicId: "1463771098767167489",
          dicItemCode: "PRODECT_DATA_FILE_TYPE_SJYL",
          dicItemName: "数据样例",
          dicItemOrder: "0",
          dicItemDesc: "产品数据文件类型-数据样例",
          createTime: "2021-11-24 08:00:00"
        },
        {
          pkid: "1463772211738316801",
          dicId: "1463771098767167489",
          dicItemCode: "PRODECT_DATA_FILE_TYPE_XGWX",
          dicItemName: "相关文献",
          dicItemOrder: "0",
          dicItemDesc: "产品数据文件类型-相关文献",
          createTime: "2021-11-24 08:00:00"
        }
      ],
      ImageServerLoading: false,
      getDataMethods: ['Searchfortherequireddata', 'Addtodataorder', 'Downloaddataonline'],
      productId: '',
      palyStatus: true,
      show2d: false,
      cunApplicationShow: false,
      centerDialogVisible: false,
      productBasiDetail: {},
      productLevel: {},
      productContact: {},
      productFileList: [],
      productFileQueryTime: {
        start: '',
        end: ''
      },
      productFileQuery: {
        pdPkid: '',
        page: 1,
        limit: 10,
        fileCreateTimeBegin: "",
        fileCreateTimeEnd: "",
      },
      dataQuery: {},
      productFileListTotal: 0,
      // ProductAppendixList1:[],//数据说明文档
      // ProductAppendixList2:[],//数据样例
      ProductAppendixList3: [],//相关文献
      UserFootList: [],
      fileUploadTime: '',
      ProfileCreateTime: {
        fileCreateTime: '',
        fileCreateTimeEnd: ''
      },
      ProfileSpaceUsage: '',
      UserDown: [],
      activePage: 'ApplicationForm',
      satelliteList: [],
      formInfo: {
        satelliteName: '',
        productDataId: '',
        productName: '',
        satelliteProductName: '',
        startTime: '',
        endTime: '',
        time: null,
        usage: '',
        limit: 3000,
        pointList: [],
        page: 1
      },
      queryInfoDetail: {
        principalValue: '',
        typeValue: [],
        typeName: "",
      },
      myChart: null,
      subStatus: true,
      legendObj: {
        principalValue: "",
        startValue: "",
        endValue: "",
        type: 1,
        valueStep: ""
      },
      imageServiceUrl: '',
      imageServiceCollections: [
        {iserverImageType: '1'}
      ],
      recorderForm: {
        productDataId: '',
        limit: 20,
        page: 1
      },
      recorderTotal: 0,
      fullMap: false,
      mapHeight: '660px'
    }
  },
  computed: {
    ...mapGetters(['shopTotal_getter', 'token_getter']),
    /**
     * @description:
     * @brief:
     * @Author: chenwei
     * @Date: 2022-07-01 13:43:40
     * @return {*}
     */
    isShowGame() {
      if (this.productId === "32" || this.productId === "2") {
        return true
      } else {
        return false
      }
    },
    isShow3DBtn() {
      if (this.imageServiceCollections[0].iserverImageType != '2' && this.imageServiceCollections[0].iserverImageType != '3' && this.imageServiceCollections[0].baseUnderUrl === '4326') {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    timeRnage: {
      handler(val) {
        this.PlayTimeRange = {
          start: val.startTime,
          end: val.endTime
        }
      },
      deep: true
    },
    show2d(val) {
      console.log(val);
      this.palyStatus = true
    },
    cunApplicationShow(val) {
      if (val) {
        this.$nextTick(() => {
          this.initProduct2Map()
        })
        this.getRunRecordFuc()
      }
    }
  },
  mounted() {
    window.onresize = () => {
      if (this.fullMap) {
        this.mapHeight = document.documentElement.clientHeight + 'px'
      }
    }
    const language = window.localStorage.getItem('language')
    if (language === 'zh') {
      this.isEnglish = false
    }
    if (language === 'en') {
      this.isEnglish = true
    }
  },
  methods: {
    /**
     * @description: 展示pdf
     * @brief:
     * @Author: chenwei
     * @Date: 2022-07-08 09:46:55
     * @param {*} url
     * @return {*}
     */
    viewPdf(url) {
      window.open(this.mediaView + url, '_blank', "width=1300,height=830,top=50,left=100")
    },
    /**
     * @description: 根据不同产品播放不同游戏引擎效果
     * @brief:
     * @Author: chenwei
     * @Date: 2022-07-01 13:45:40
     * @return {*}
     */
    openGameVideo() {
      if (this.productId === "32") {
        window.open('http://120.196.115.131:8101/productImages/piaoyi.mp4', '_blank', "width=1300,height=830,top=50,left=1500")
      } else {
        window.open('http://120.196.115.131:8101/productImages/leixing.mp4', '_blank', "width=1300,height=830,top=50,left=1500")
      }

    },
    renderLegend() {
      let c_list = this.queryInfoDetail.principalValue.split(',')
      let a = colorpicks(c_list, 100)
      var can = document.getElementById("legendDe");
      var cans = can.getContext('2d');
      //创建一个线性渐变对象
      var gnt1 = cans.createLinearGradient(0, 160, 0, 0);
      a.forEach((element, index) => {
        gnt1.addColorStop(index * (1 / a.length), element);
      });
      cans.fillStyle = gnt1;
      //绘制一个矩形
      cans.fillRect(0, 0, 240, 160);
    },
    stopAnimate() {
      this.palyStatus = true
    },
    timeUnit(val) {
      switch (val) {
        case 'y':
          return this.isEnglish ? 'year' : '年'
        case 'M':
          return this.isEnglish ? 'month' : '月'
        case 'd':
          return this.isEnglish ? 'day' : '日'
        case 'H':
          return this.isEnglish ? 'h' : '时'
        case 'm':
          return this.isEnglish ? 'minute' : '分'
        default:
          return ''
      }
    },
    avg(array) {//封装求平均值函数
      const len = array.length
      let sum = 0
      for (let i = 0; i < len; i++) {
        sum += array[i]
      }
      return sum / len
    },
    stdDeviation(arr) {
      let sd,
          ave,
          sum = 0,
          sums = 0,
          len = arr.length
      for (let i = 0; i < len; i++) {
        sum += Number(arr[i])
      }
      ave = sum / len
      for (let i = 0; i < len; i++) {
        sums += (Number(arr[i]) - ave) * (Number(arr[i]) - ave)
      }
      sd = (Math.sqrt(sums / len)).toFixed(2)
      return sd
    },
    searchHistoryData(longitude, latitude) {
      let that = this
      that.dataSearchLatLng = {
        lat: latitude.toFixed(6),
        lng: longitude.toFixed(6)
      }
      let tableItemIndex = 0
      const promiseArray = []
      const timeArray = []
      let chartKey = []
      const valueList = []
      let newdataQuery = JSON.parse(JSON.stringify(that.dataQuery.list))
      newdataQuery = newdataQuery.reverse()
      newdataQuery.forEach(element => {
        const url = this.iserverHeader + element + '/gridValue.rjson?&x=' + longitude + '&y=' + latitude
        const promise = axios.get(url)
        promiseArray.push(promise)
        timeArray.push(element.split('/').pop().split('_').pop())
      });
      Promise.all(promiseArray).then(result => {
        that.tableList = []
        for (let i = 0; i < Math.ceil(that.dataQuery.list.length / 2); i++) {
          that.tableList[i] = []
        }
        result.forEach(item => {
          const index = parseInt(tableItemIndex / 2)
          that.tableList[index].push(timeArray[tableItemIndex])
          let value = item.data.value
          let chartValue = item.data.value
          if (value === -9999) {
            value = 'NaN'
            chartValue = 0
          }
          valueList.push(parseFloat(chartValue.toFixed(2)))
          if (value === 'NaN') {
            that.tableList[index].push(value)
          } else {
            that.tableList[index].push(parseFloat(value.toFixed(2)))
          }
          tableItemIndex++
        })
        // 计算最大值，最小值，平均值，标准差
        that.computedObj = {
          max: {},
          min: {},
          ave: '',
          sta: ''
        }
        const computeArray = []
        that.tableList.forEach(item => {
          if (item[1] && item[1] !== 'NaN') {
            computeArray.push(item[1])
          }

          if (item[3] && item[3] !== 'NaN') {
            computeArray.push(item[3])
          }
        })
        let maxTime = ''
        let minTime = ''
        const maxValue = computeArray.sort(function (a, b) {
          return a - b
        })[computeArray.length - 1]
        const minValue = computeArray.sort(function (a, b) {
          return a - b
        })[0]
        that.tableList.forEach(item => {
          if (item[1] === maxValue) {
            maxTime = item[0]
          }
          if (item[3] === maxValue) {
            maxTime = item[2]
          }
          if (item[1] === minValue) {
            minTime = item[0]
          }
          if (item[3] === minValue) {
            minTime = item[2]
          }
        })
        that.computedObj.max = {
          value: maxValue,
          time: maxTime
        }
        that.computedObj.min = {
          value: minValue,
          time: minTime
        }
        that.computedObj.ave = (that.avg(computeArray)).toFixed(2)
        that.computedObj.sta = that.stdDeviation(computeArray)
        // 更新折线图
        // const chartData = {}
        // chartData[chartKey[0]] = valueList.splice(0,12)
        // chartData[chartKey[1]] = valueList.splice(0,12)
        const backdata = {
          // chartData:chartData,
          computedObj: that.computedObj,
          tableList: that.tableList,
          chartKey: chartKey
        }
        that.backData(backdata)
      }).catch((err) => {
        console.log('\n\n\n\n\n\n\n*********************************\n************************');
        console.log(err);
        this.$message.warning(this.isEnglish ? 'Out of range of data' : '超出数据范围')
      })
    },
    backData(val) {
      console.log(val);
      this.rightDynamic = val
      // this.drawMarker()
      // if(this.show2d){
      //   this.$refs.CesiumMapShow.drawMarker()
      // }
    },
    drawMarker() {
      this.cancelDraw()
      if (this.show2d) {
        this.$refs.CesiumMapShow.drawMarker()
      } else {
        this.$refs.InitMapShow.getMarker()
      }
    },
    cancelDraw() {
      let flatMap = document.getElementById('product')
      if (flatMap) {
        flatMap.style.cursor = 'auto'
      }
      if (this.show2d) {
        this.$refs.CesiumMapShow.cancelDraw()
      } else {
        this.$refs.InitMapShow.cancelMarker()
      }
    },
    changeTime(time) {
      let now = new Date(time),
          Y = now.getFullYear(),
          M = now.getMonth() + 1,
          D = now.getDate()
      M = M < 10 ? '0' + M : M;
      D = D < 10 ? '0' + D : D;
      return Y + '-' + M + '-' + D;
    },
    fullS() {
      this.fullscreenClass = new FullScreen('htmlToImage')
      if (!this.fullscreen) {
        this.fullscreenClass.full()
      } else {
        this.fullscreenClass.unfull()
      }
      this.fullscreen = !this.fullscreen;
    },
    contalScreen() {
      if (!this.disabled.start) {
        this.ScreenReC.start()
        return
      }
      if (!this.disabled.stop) {
        this.ScreenReC.stop()
        return
      }
    },
    toImage() {
      function getImageWithText(canvas, text) {

        const context = canvas.getContext("2d");
        context.font = "10px Arial";
        context.fillStyle = "#000";
        context.fillRect(
            0,
            canvas.height - 30,
            context.measureText(text).width + 20,
            30
        );

        context.fillStyle = "#fff";
        context.fillText(text, 10, canvas.height - 10);

        return canvas.toDataURL("image/png");
      }

      function downloadImage(filename, dataUrl) {
        let alink = document.createElement('a')
        alink.href = dataUrl
        alink.download = filename + '.png'
        alink.click()
        return;
      }

      function exportImage(id) {

        html2canvas(document.querySelector("#" + id), {allowTaint: true, useCORS: true}).then(canvas => {

          let dataUrl = getImageWithText(canvas, "SYWater-2020©");

          downloadImage("sywater-gis", dataUrl)

        });
      }

      exportImage('htmlToImage')
    },
    measureLength(command) {
      if (this.show2d) {
        this.$refs.CesiumMapShow.ceju(command)
      } else {
        this.cancelDraw()
        this.$refs.InitMapShow.ceju(command)
      }
    },
    cemian() {
      if (this.show2d) {
        this.$refs.CesiumMapShow.cemian()
      } else {
        this.cancelDraw()
        this.$refs.InitMapShow.cemian()
      }
    },
    async subData() {
      if (this.promisShow(1)) {
        return
      }
      let that = this
      let params = {
        pdId: that.productBasiDetail.pkid,
        productName: that.productBasiDetail.dataName,
      }
      let res = await addSubscribe(params)
      if (res.code == '000000') {
        that.$message.success(this.isEnglish ? 'Subscribe to the success' : '订阅成功')
      }
      this.isSubs()
    },
    async collectData() {
      if (this.promisShow(1)) {
        return
      }
      let that = this
      let params = {
        pdId: that.productBasiDetail.pkid,
        productName: that.productBasiDetail.dataName,
      }
      let res = await addCollect(params)
      if (res.code == '000000') {
        that.$message.success(this.isEnglish ? 'Collection of success' : '收藏成功')
      }
      this.isCollect()
    },
    startFeng() {
      this.$refs.CesiumMapShow && this.$refs.CesiumMapShow.creatWind()
      this.$refs.InitMapShow && this.$refs.InitMapShow.creatWind()
    },
    isFullMap() {
      this.fullMap = !this.fullMap
      this.mapHeight = '660px'
      if (this.fullMap) {
        this.mapHeight = document.documentElement.clientHeight + 'px'
      }
    },
    async ApplyRunOrderFuc(val) {
      let res = await ApplyRunOrder({applyId: val})
      if (res) {
        this.$message.success(this.isEnglish ? 'Order generation succeeded' : '生成订单成功')
      }
    },
    currentChangeRecoprd(val) {
      this.recorderForm.page = val
      this.getRunRecordFuc()
    },
    async getRunRecordFuc() {
      let {data} = await getRunRecord(this.recorderForm)
      let res = data
      this.tableData = res.list
      this.recorderTotal = parseFloat(res.totalCount)
    },
    clearProTime() {
      this.productFileQueryTime = {
        start: '',
        end: ''
      }
      this.changeProductFileQueryTime()
    },
    changeProductFileQueryTime() {
      let val = this.productFileQueryTime
      if (this.productFileQueryTime.start && this.productFileQueryTime.end && val.length != 0) {
        this.productFileQuery.fileCreateTimeBegin = val.start + ' 00:00:00'
        this.productFileQuery.fileCreateTimeEnd = val.end + ' 23:59:59'
      } else {
        this.productFileQuery.fileCreateTimeBegin = ''
        this.productFileQuery.fileCreateTimeEnd = ''
      }
      this.getProductFileFuc()
    },
    async apply() {
      let that = this
      that.formInfo.pointList = that.drawDataMap
      if (that.formInfo.pointList.length != 0) {
        let {data} = await ApplyForRun(this.formInfo)
        let res = data
        this.cunApplicationShow = false
        this.$message.success(this.isEnglish ? 'application approved' : '申请成功');
        this.formInfo.time = null
        this.formInfo.pointList = []
        this.formInfo.usage = ''
        console.log(res);
      } else {
        that.$message.error(this.isEnglish ? 'Please enter valid values and space ranges' : '请输入有效值和空间范围')
      }
      // let {data} = await ApplyForRun(this.formInfo)
      // let res = data
      // this.cunApplicationShow = false
      // this.$message.success('申请成功');
      // this.formInfo.time = null
      // this.formInfo.pointList = []
      // this.formInfo.usage = ''
      // console.log(res);
    },
    addRectArea() {
      this.$message(this.isEnglish ? 'Start box range' : '开始框选范围');
      this.drawDataMap = []
      var that = this;
      this.product2MapDrawGroup.clearLayers()
      if (that.stopRectArea != null) {  //stopRectArea在data中定义，清除重复的拉框操作
        that.product2Map.off('mousedown', that.stopRectArea.mousedown);
      }
      var rectangleMeasure = {
        startPoint: null,
        endPoint: null,
        rectangle: null,
        layer: this.product2MapDrawGroup,
        color: "rgba(51,136,255,1)",
        addRectangle: function () {
          rectangleMeasure.destory();
          var bounds = [];
          bounds.push(rectangleMeasure.startPoint);
          bounds.push(rectangleMeasure.endPoint);
          rectangleMeasure.rectangle = L.rectangle(bounds, {color: rectangleMeasure.color, weight: 1});
          rectangleMeasure.rectangle.addTo(rectangleMeasure.layer);
          rectangleMeasure.layer.addTo(that.product2Map);
        },
        mousedown: function (e) {
          rectangleMeasure.rectangle = null;
          that.product2Map.dragging.disable();
          rectangleMeasure.startPoint = e.latlng;
          that.product2Map.on('mousemove', rectangleMeasure.mousemove)
        },
        mousemove: function (e) {
          rectangleMeasure.endPoint = e.latlng;
          rectangleMeasure.addRectangle();
          that.product2Map.off('mousedown ', rectangleMeasure.mousedown).on('mouseup', rectangleMeasure.mouseup);
        },
        mouseup: function () {
          that.product2Map.dragging.enable();
          that.product2Map.off('mousemove', rectangleMeasure.mousemove).off('mouseup', rectangleMeasure.mouseup);
          that.locations = {}; //locations在data中定义
          that.locations['leftX'] = rectangleMeasure.startPoint.lat;
          that.locations['leftY'] = rectangleMeasure.startPoint.lng;
          that.locations['rightX'] = rectangleMeasure.endPoint.lat;
          that.locations['rightY'] = rectangleMeasure.endPoint.lng;
          that.locations['layer_id'] = rectangleMeasure.layer._leaflet_id;
          that.locations['layer'] = rectangleMeasure.layer;
          that.locations['rectangle'] = rectangleMeasure.rectangle;
          that.drawDataMap.push([rectangleMeasure.startPoint.lat, rectangleMeasure.startPoint.lng])
          that.drawDataMap.push([rectangleMeasure.endPoint.lat, rectangleMeasure.startPoint.lng])
          that.drawDataMap.push([rectangleMeasure.endPoint.lat, rectangleMeasure.endPoint.lng])
          that.drawDataMap.push([rectangleMeasure.startPoint.lat, rectangleMeasure.endPoint.lng])
        },
        destory: function () {
          if (rectangleMeasure.rectangle)
            rectangleMeasure.layer.removeLayer(rectangleMeasure.rectangle);
        }
      };
      that.stopRectArea = rectangleMeasure; //记录已点击拉框按钮，未在地图上拉框
      that.product2Map.on('mousedown', rectangleMeasure.mousedown); //在地图上拉框
    },
    addAllArea(arrs) {
      let a = []
      arrs.forEach(element => {
        a.push([parseFloat(element[1]), parseFloat(element[0])])
      });
      a.splice(a.length - 1, 1)
      var polygon = L.polygon(a, {color: 'red'});
      this.product2MapGroup.addLayer(polygon)
    },
    initProduct2Map() {
      const url = "http://120.196.115.131:8091/geoesb/proxy/services/maps/rest/6f3449b32fee4c1d89ecbbac5b24b64f/886e60bb7e014f22a707de23e6f6505d";
      this.product2Map = L.map('product2', {
        crs: L.CRS.EPSG4326,
        center: [0, 0],
        maxZoom: 18,
        zoomControl: false,
        attributionControl: false,
        zoom: 1,
      });
      tiledMapLayer(url, {
        noWrap: true
      }).addTo(this.product2Map);
      this.product2MapGroup = L.layerGroup().addTo(this.product2Map);
      this.product2MapDrawGroup = L.layerGroup().addTo(this.product2Map);
    },
    async runApplication(val) {
      this.formInfo.startTime = val + ' 00:00:00'
      this.formInfo.endTime = val + ' 23:59:59'
      let {data} = await getSatelliteFileData(this.formInfo)
      let res = data
      res.list.forEach(element => {
        this.addAllArea(element.location_shape.coordinates[0])
      });

    },
    closeRunApplicationShow() {
      this.cunApplicationShow = false
      this.formInfo.time = null
      this.formInfo.pointList = []
      this.formInfo.usage = ''
    },
    openDialog() {
      this.palyStatus = true
      this.centerDialogVisible = true

      let end = this.ProfileCreateTime.fileCreateTimeEnd
      let start = this.ProfileCreateTime.fileCreateTime

      let scopeValue = [];
      scopeValue.push(start);
      scopeValue.push(end);
      this.timeRnage = {
        startTime: this.ProfileCreateTime.fileCreateTime.substr(0, 10),
        endTime: this.ProfileCreateTime.fileCreateTimeEnd.substr(0, 10),
      }
      this.PlayTimeRange = {
        start: this.ProfileCreateTime.fileCreateTime.substr(0, 10),
        end: this.ProfileCreateTime.fileCreateTimeEnd.substr(0, 10)
      }
      this.$nextTick(() => {
        try {
          // this.initInfoEchart3()
          this.renderLegend()
        } catch (error) {
          console.log(error);
        }

      })
    },
    initInfoEchart3() {
      this.myChart = echarts.init(document.getElementById('rightE2'));
      // 绘制图表
      this.myChart.setOption(
          {
            title: {
              text: '变化趋势:',
              textStyle: {
                color: 'rgba(181, 252, 255, 1)',
                fontSize: 12
              },
            },
            legend: {
              data: ['2018年', '2017年'],
              textStyle: {
                color: 'rgba(255, 255, 255, 1)'
              },
              right: '1%',
              itemHeight: 6
            },
            grid: {
              left: '3%',
              right: '4%',
              bottom: '8%',
              top: "22%",
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              axisTick: {
                show: false
              },
              axisLabel: {
                color: 'white'
              },
              data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
            },
            yAxis: {
              axisLine: {
                show: false,
              },
              splitLine: {
                lineStyle: {
                  type: 'dashed',
                  color: 'rgba(121, 169, 218, 0.2)'
                },
              },
              axisLabel: {
                color: 'white'
              },
              type: 'value'
            },
            series: [
              {
                name: '2018年',
                type: 'line',
                stack: 'Total',
                areaStyle: {
                  //区域填充样式
                  normal: {
                    //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                    color: new echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                          {
                            offset: 0,
                            color: "rgba(0, 108, 255, 0.7)",
                          },
                          {
                            offset: 1,
                            color: "rgba(0, 108, 255, 0)",
                          },
                        ],
                        false
                    ),
                    shadowColor: "rgba(0, 108, 255, 0.7)", //阴影颜色
                  },
                },
                data: []
              },
              {
                name: '2017年',
                type: 'line',
                stack: 'Total',
                areaStyle: {
                  //区域填充样式
                  normal: {
                    //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
                    color: new echarts.graphic.LinearGradient(
                        0,
                        0,
                        0,
                        1,
                        [
                          {
                            offset: 0,
                            color: "rgba(0, 255, 240, 1)",
                          },
                          {
                            offset: 1,
                            color: "rgba(0, 255, 240, 0)",
                          },
                        ],
                        false
                    ),
                    shadowColor: "rgba(0, 255, 240, 0.5)", //阴影颜色
                  },
                },
                data: []
              }
            ]
          }
      );
    },
    startPlay() {
      this.PlayTimeRange = {
        start: this.timeRnage.startTime,
        end: this.timeRnage.endTime
      }
      this.palyStatus = false
    },
    async getUserDownFuc() {
      let that = this
      let {data} = await getUserDown({pdId: this.productId})
      let res = data
      that.UserDown = res
    },
    async getProductFileSizeFuc() {
      let that = this
      let {data} = await getProductFileSize({pdId: this.productId})
      let res = data
      that.ProfileSpaceUsage = res
    },
    async getProductDetailTimeFuc() {
      let that = this
      let {data} = await getProductDetailTime({pdId: this.productId})
      let res = data
      that.ProfileCreateTime = res
    },
    async getProductUpdateTimeFuc() {
      let that = this
      let {data} = await getProductUpdateTime({pdId: this.productId})
      let res = data
      that.fileUploadTime = res
    },
    selectAllProduct(val) {
      this.productFileList.forEach(element => {
        element.selectStatus = val
      });
    },
    currentChange(val) {
      this.productFileQuery.page = val
      this.getProductFileFuc()
    },
    async getDetail() {
      let {data} = await getProductDetail({id: this.productId})
      let res = data
      this.productBasiDetail = res
      this.getContactUer(res.dataContact)
    },
    async getProductLevelFuc() {
      let {data} = await getProductLevel({pdId: this.productId})
      let res = data
      res.level = parseInt(res.level)
      this.productLevel = res
    },
    async getContactUer(val) {
      let {data} = await getProductContact({dataContactId: val})
      let res = data
      this.productContact = res
    },
    async getProductFileFuc() {
      let that = this
      let params = JSON.parse(JSON.stringify(that.productFileQuery))
      params.page = JSON.stringify(params.page)
      params.limit = JSON.stringify(params.limit)
      let {data} = await getProductFile(params)
      let res = data
      that.productFileList = res.list
      that.productFileList.forEach(element => {
        that.$set(element, 'selectStatus', false)
      });
      that.productFileListTotal = parseInt(res.totalCount)

      that.allSelect = false
    },
    async getProductAppendixFuc() {
      let that = this
      let {data} = await getProductAppendix({pdId: this.productId})
      let res = data
      // that.ProductAppendixList1 = res.filter(item => item.fileType == '1463771955055300609')
      // that.ProductAppendixList2 = res.filter(item => item.fileType == '1463772062400122881')
      that.ProductAppendixList3 = res.filter(item => item.fileType == '1463772211738316801')
      if (that.ProductAppendixList3.length == 0) {
        if (this.isEnglish) {
          that.ProductAppendixList3.push({fileName: "no file"});
        } else {
          that.ProductAppendixList3.push({fileName: "无"});
        }
      }
    },
    down(val) {
      console.log(val);
    },
    async getUserFoot() {
      let {data} = await getProductBrowse({footType: '1464159606501543938'})
      let res = data
      this.UserFootList = res
    },
    async addAllFileToCar() {
      if (this.productFileList.length === 0) {
        this.$message.warning('该产品没有上传产品文件!')
        return
      }
      if (this.productBasiDetail.dataShareLevelName === '完全共享') {
        if (this.promisShow(1)) {
          return
        }
      } else {
        if (this.promisShow(2)) {
          return
        }
      }
      let that = this
      await addProductAllFileToCar({
        'productId': that.productBasiDetail.pkid,
        'productName': that.productBasiDetail.dataName
      }).then(() => {
        this.$message({
          message: this.isEnglish ? 'Shopping cart added successfully' : '添加购物车成功',
          type: 'success'
        });
      })
      setTimeout(() => {
        this.$store.dispatch('getShopTotal')
      }, 2000)
    },
    async addSelectFilesToCar() {
      if (this.productBasiDetail.dataShareLevelName === '完全共享') {
        if (this.promisShow(1)) {
          return
        }
      } else {
        if (this.promisShow(2)) {
          return
        }
      }
      let that = this
      let selectItems = that.productFileList.filter(item => item.selectStatus === true)
      let fileIdList = []
      selectItems.forEach(e => {
        fileIdList.push(e.pkid)
      })
      if (fileIdList.length === 0) {
        that.$message({
          message: this.isEnglish ? 'Please select what you want to add' : '请选择要添加的内容',
          type: 'error'
        });
      } else {
        await addCarForProduct({
          "fileIdList": fileIdList,
          "productId": that.productBasiDetail.pkid,
          "productName": that.productBasiDetail.dataName,
        }).then(res => {
          console.log(res)
          that.$message({
            message: this.isEnglish ? 'Shopping cart added successfully' : '添加购物车成功',
            type: 'success'
          });
        })
      }
      this.$store.dispatch('getShopTotal')
    },
    async addSingleFileToCar(e) {
      if (this.productBasiDetail.dataShareLevelName === '完全共享') {
        console.log('这是完全共享的');
        if (this.promisShow(1)) {
          return
        }
      } else {
        if (this.promisShow(2)) {
          return
        }
      }
      let that = this
      let fileIdList = []
      fileIdList.push(e)
      await addCarForProduct({
        "fileIdList": fileIdList,
        "productId": that.productBasiDetail.pkid,
        "productName": that.productBasiDetail.dataName,
      }).then(res => {
        console.log(res)
        that.$message({
          message: this.isEnglish ? 'Shopping cart added successfully' : '添加购物车成功',
          type: 'success'
        });
        this.$store.dispatch('getShopTotal')
      })
    },
    //查询影像服务地址和集合
    async getProductImageServiceInfoFuc() {
      let that = this
      that.ImageServerLoading = false
      let {data} = await getProductImageServiceInfo({productDataId: that.productId})
      let res = data
      that.dataQuery = {
        list: res.iserverDataSetUrls,
        url: res.iserverDataUrl
      }
      that.getQueryProductInfo()
      that.imageServiceUrl = res.productImagingService
      that.imageServiceCollections = res.productDataImagingResList

      if (res.productDataImagingResList[0].iserverImageType == '1') {
        let urlO = res.productImagingService + '/' + res.productDataImagingResList[0].resourceName + '/tempLayersSet?returnPostAction=true&getMethodForm=true'
        let xqOption = await getXQDataOption({urlPart: urlO})
        xqOption = JSON.parse(xqOption.data)
        that.imageServiceCollections[0].xqOption = xqOption
        console.log(xqOption);
      }

      that.ImageServerLoading = true

    },
    async getQueryProductInfo() {
      let that = this
      let res = await queryProductInfo({id: this.productId})
      that.queryInfoDetail = res.data
      try {
        that.dialogInfo.productRibbonUnit = res.data.productRibbonUnit
        that.dialogInfo.simpleName = res.data.pkid
        that.dialogInfo.coordinates = res.data.coordinates

        that.dialogInfo.totalProductDownVOS = res.data.totalProductDownVOS
        that.dialogInfo.leImg = res.data.summarizeImages[0] && res.data.summarizeImages[0].mediaUrl
        that.dialogInfo.rImg = res.data.dataOtherImages[0] && res.data.dataOtherImages[0].mediaUrl
        that.dialogInfo.le1 = res.data.dataDesc
        that.dialogInfo.timeResolutionUnit = res.data.timeResolutionUnit
        //输入
        that.dialogInfo.le3 = res.data.dataSource && res.data.dataSource.split(';')

        that.dialogInfo.r1 = res.data.dataOtherDesc

        that.dialogInfo.le2 = {
          lx: res.data.dataFormat,
          kjfbl: res.data.spatialResolution,
          sjfbl: res.data.timeResolution,
          sjfblunit: res.data.timeResolutionUnit,
          kjwz: res.data.dataLocation,
          sjsj: (res.data.productFileStartTime ? res.data.productFileStartTime.substr(0, 10) : '未知') + ' 至 ' + (res.data.productFileEndTime ? res.data.productFileEndTime.substr(0, 10) : '未知'),
        }
        if (this.isEnglish) {
          that.dialogInfo.le2.sjsj = (res.data.productFileStartTime ? res.data.productFileStartTime.substr(0, 10) : '未知') + ' To ' + (res.data.productFileEndTime ? res.data.productFileEndTime.substr(0, 10) : '未知')
        }
        if (res.data.xpoint && res.data.ypoint) {
          const lng = parseFloat(res.data.xpoint)
          const lat = parseFloat(res.data.ypoint)
          that.dataSearchLatLng = {
            lat: lat.toFixed(6),
            lng: lng.toFixed(6)
          }
          that.searchHistoryData(lng, lat)
        }
        if (!res.data.principalValue) {
          res.data.principalValue = ''
        }
        if (res.data.ribbonStep) {
          let valueStep = (res.data.endValue - res.data.startValue) / res.data.ribbonStep
          that.legendObj = {
            principalValue: res.data.principalValue,
            startValue: res.data.startValue,
            endValue: res.data.endValue,
            valueStep: valueStep
          }
        } else if (res.data.ribbonLevel) {
          that.legendObj = {
            principalValue: res.data.principalValue,
            startValue: res.data.startValue,
            endValue: res.data.endValue,
            valueStep: res.data.ribbonLevel
          }
        }
      } catch (error) {
        console.log(error);
      }

    },
    async queryCoordinatesFun() {
      let that = this
      that.areaRangeLoading = false
      let res = await queryCoordinates({id: that.productId})
      that.areaRangeLoading = true
      const {N, S, W, E} = res.data
      that.areaRange = [[N, W], [N, E], [S, E], [S, W]]
      console.log(res);
    },
    async isSubs() {
      let that = this
      let res = await getSubscribeList({pdId: that.productId})
      that.subStatus = res.data.list.length > 0 ? false : true
    },
    async isCollect() {
      let that = this
      let res = await getCollectList({pdId: that.productId})
      that.collectStatus = res.data.list.length > 0 ? false : true
    },
  },
  created() {
    this.ScreenReC = new ScreenRe(this.disabled)

    this.productId = this.$route.query.ProductId
    this.productFileQuery.pdPkid = this.$route.query.ProductId
    this.formInfo.productDataId = this.$route.query.ProductId
    this.recorderForm.productDataId = this.$route.query.ProductId
    this.getProductImageServiceInfoFuc()

    this.getDetail()
    this.getProductLevelFuc()
    this.getProductFileFuc()
    this.getProductAppendixFuc()
    this.getUserFoot()
    this.getProductUpdateTimeFuc()
    this.getProductDetailTimeFuc()
    this.getProductFileSizeFuc()
    this.getUserDownFuc()
    this.queryCoordinatesFun()
    if (this.token_getter) {
      this.isSubs()
      this.isCollect()
    }
  }
}
</script>

<style lang="scss">
.main-map-wh > .map {
  // @include map_bg();
  background: transparent;
}

.map-L {
  .map {
    &.leaflet-container {
      //   @include map_bg();
      background: transparent
    }
  }
}

.product-dialog-theme {
  @include product_productMap_bg();
}

.time-step {
  position: absolute;
  right: calc(50% - 340px);
  bottom: 10px;
  z-index: 1000;
}

@media screen and (min-width: 1590px) {

  .change-map {
    bottom: 32px;
  }
}

@media screen and (max-width: 1590px) {

  .change-map {
    bottom: 68px;
  }
}
</style>
<style lang="scss" scoped>
.tool-p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 22px;
  text-shadow: 0px 1px 2px rgba(4, 11, 34, 0.1500);
}

@media screen and (min-width: 1527px) {
  .legend-my {
    bottom: 12px;
  }
}

@media screen and (max-width: 1527px) {
  .legend-my {
    bottom: 80px;
  }
}

.legend-my {
  position: absolute;
  left: 8px;
  z-index: 100000;

  .top-line {
    padding: 8px;
    background-image: url("../../assets/image/product-detail-dialog/sedai-bg.png");
    background-size: 100% 100%;
    display: flex;

    .l1 {
      width: 28px;
      height: 160px;
    }

    .r1 {
      height: 160px;
    }
  }

  .unit {
    color: white;
    position: absolute;
    bottom: 180px;
    white-space: nowrap;

    // -webkit-text-stroke:.5px black;
    // text-shadow: 0 0 300px rgb(5,13,34);
    text-shadow: 2px 2px 5px rgb(5, 13, 34);
  }

  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 160px;

    p {
      display: inline;
      color: white;
    }
  }

  .legend-show {
    width: 24px;
    height: 160px;
  }

  .legend-fenduan-show {
    height: 160px;
    display: flex;
    flex-direction: column;

    .fen-duan-site {
      width: 24px;
      flex: 1;
      position: relative;
    }

    .value-s {
      position: absolute;
      left: 30px;
      top: 8px;
      color: white;
      display: inline
    }
  }

  .legend-fenduan-show2 {
    // height: 160px;
    // display: flex;
    // flex-direction: column;
    .fen-duan-site {
      flex: 1;
      position: relative;
      line-height: 28px;
      color: white;
    }
  }

}

/deep/ .el-input__inner {
  color: rgb(233, 229, 229);
}

/deep/ .el-textarea__inner {
  color: rgb(233, 229, 229);
}

.main-map-wh {
  width: 100%;
  height: 100%;
  // background-color: rgba(5,50,89,1);
  // background: rgba(5,50,89,1);
  background-image: url("../../assets/image/product-view-dialog/ditu.png");
}

hr {
  margin: 12px 0;
  @include product_hr_v1_color();
}

.product-data {
  width: 100%;
  @include co_white_to_black();

  .content {
    @include product_bg_v1_color();
    width: 100%;

    .bl-title {
      color: rgba(38, 125, 255, 1);
      font-weight: 600;
      font-size: 18px;
    }

    .label {
      display: flex;
      align-items: center;
      height: 60px;
      @include product_bg_v2_color();
      padding-left: 60px;

      /deep/ span {
        font-size: 15px;
        @include co_white_to_black();
      }

      /deep/ a {
        @include co_white_to_black();
      }

      /deep/ .el-breadcrumb__item:last-child {
        span {
          color: rgba(38, 125, 255, 1);
        }
      }

    }

    .padding-box {
      padding: 0 240px;
    }

    .name {
      text-align: center;
      font-size: 26px;
      padding: 20px 0;
    }

    .date-num-level-box {
      // background-color: rgba(69,70,71,1);
      .labels {
        font-size: 40px;
      }

      .la1 {
        @include product_label_la1_color();
      }

      .la2 {
        @include product_label_la2_color();
      }

      .la3 {
        @include product_label_la3_color();
      }

      .la4 {
        @include product_label_la4_color();
      }

      @include product_levelbg_v1_color();
      height: 120px;
      width: 100%;
      border-radius: 6px;
      display: flex;
      justify-content: center;
      margin-bottom: 12px;

      .label-site {
        display: flex;
        align-items: center;
        margin: 0 70px;

        .logo {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          margin-right: 10px;

          svg {
            width: 40px;
            height: 40px;
          }
        }

        .label-text {
          font-size: 14px;
          color: white;
        }
      }
    }

    .info-box {
      display: flex;

      .left {
        width: 1076px;
        margin-right: 24px;

        .layout-box {
          display: flex;
          justify-content: space-between;
          font-size: 15px;

          .basic-info {
            width: 48%;

            &-site {
              display: flex;
              align-items: center;
              margin: 5px 0;
            }

            &-title {
              min-width: 80px;
              text-align: justify;
              height: 20px;
            }

            //&-title:after {
            //  display: inline-block;
            //  content: "";
            //  width: 80px;
            //}
            &-value {
              flex: 1;
            }
          }

          .basic-info-en {
            .basic-info-title {
              min-width: 140px;
            }
          }

          .connect {
            width: 48%;

            &-site {
              display: flex;
              align-items: flex-start;
              margin: 5px 0;
            }

            &-title {
              //width: 66px;
              text-align: justify;
              height: 20px;
            }

            //&-title:after {
            //  display: inline-block;
            //  content: "";
            //  width: 66px;
            //}
            &-value {
              flex: 1;
              //text-align: start;
              word-break: break-all;
            }
          }

          .connect-en {
            .connect-title {
              min-width: 90px;
            }
          }
        }

        .get-data {
          margin-top: 18px;
        }

        .time-line {
          display: flex;
          justify-content: center;
          margin: 50px 0 80px 0;

          .line-site {
            width: 406px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .circle {
              position: relative;
              width: 20px;
              height: 20px;
              border-radius: 50px;
              background: rgba(25, 144, 255, 1);
              color: white;

              .line {
                width: 363px;
                height: 2px;
                border: 0;
                //    background: rgba(232,232,232,1);
                background: rgba(25, 144, 255, 1);
                position: absolute;
                left: 8px;
                top: 50%;
                transform: translate(0, -50%);
              }
            }

          }
        }

        .date-tools {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .sub-collect {
            cursor: pointer;
            color: rgba(38, 125, 255, 1);
            border: 1px solid rgba(38, 125, 255, 1);
            border-radius: 3px;
            padding: 10px 36px;
            margin-left: 24px;
          }

          .add {
            margin-left: 24px;
            cursor: pointer;
            color: white;
            padding: 10px 36px;
            border-radius: 3px;
            border: 1px solid rgba(38, 125, 255, 0);
            background-color: rgba(38, 125, 255, 1);
          }
        }
      }

      .right {
        width: 340px;
        height: 480px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .map-L {
          width: 100%;
          margin-top: 12px;
          height: calc(100% - 200px - 12px);
          position: relative;
        }

        .mask {
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background: rgba(115, 163, 230, 0.15);
          box-shadow: 0px 3px 12px 0px rgba(185, 201, 222, 0.2);
          z-index: 500;
          pointer-events: none;
        }

        .product-image {
          background-color: white;
          height: 200px;
          width: 100%;
        }

        .view-animation {
          width: auto;
          padding: 0 10px;
          height: 28px;
          cursor: pointer;
          background: #5DA2FF;
          box-shadow: 0px 2px 8px 0px rgba(0, 66, 143, 0.3);
          border-radius: 6px;
          position: absolute;
          bottom: 12px;
          right: 12px;

          display: flex;
          align-items: center;

          font-size: 15px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 28px;

          z-index: 600;
        }
      }
    }

    .summary {
      margin: 12px 0 24px 0;

      &-content {
        text-indent: 2em;
      }
    }

    .annex {
      .an-content {
        font-size: 14px;
        margin: 8px 0;

        .down {
          color: rgba(38, 125, 255, 1);
          font-weight: 600;
          cursor: pointer;
          margin-left: 120px;
        }
      }

      .a1 {
        font-weight: 600;
      }
    }

    .use-info {
      margin-top: 24px;

      .use-content {
        text-align: justify;
        margin: 6px 0;

        .down {
          color: rgba(38, 125, 255, 1);
          font-weight: 600;
          cursor: pointer;
          margin-left: 80px;
        }
      }

      .u1 {
        font-weight: 600;
      }
    }

    .important-hint {
      padding-left: 36px;
    }

    .table-data {
      display: flex;
      padding: 0 240px;
      margin-top: 24px;
      padding-bottom: 12px;

      .left {
        flex: 4;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .tables {
          min-height: 60px;

          .tb-center {
            display: flex;
            align-items: center;
          }

          .t1 {
            @extend .tb-center;
            justify-content: center;
            width: 80px;
          }

          .t2 {
            @extend .tb-center;
            width: 200px;

            span {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .t3 {
            @extend .tb-center;
            width: 120px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .t4 {
            @extend .tb-center;
            width: 120px;
          }

          .t5 {
            @extend .tb-center;
            width: 180px;
          }

          .t6 {
            @extend .tb-center;
            justify-content: center;
            width: 120px;

          }

          &-header {
            display: flex;
            margin-bottom: 12px;
          }

          &-body {
            max-height: 560px;
            @include product_bo_t2b_color();

            .body-site {
              width: calc(100% - 2px);
              height: 48px;
              @include product_bo_color();
              border-top: 0;
              display: flex;

            }

            .body-site:last-child {
              width: calc(100% - 2px);
              height: 48px;
              @include product_bo_last_color();
              border-top: 0;
              border-bottom: 0;
              display: flex;
            }
          }
        }

        .tools-box {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 50px;

          .check {
            width: 80px;
          }

          .batch {
            width: auto;
          }

          ::v-deep .btn-next {
            margin-right: 0;
          }

          ::v-deep .el-pagination {
            padding-right: 0;
          }
        }
      }

      .right {
        flex: 3;
        margin-left: 36px;

        .top {
          .tables-user {
            min-height: 60px;

            .tb-center {
              display: flex;
              align-items: center;

            }

            .t1 {
              @extend .tb-center;
              width: 110px;
            }

            .t2 {
              @extend .tb-center;
              width: 330px;

              span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .t3 {
              @extend .tb-center;
              width: 180px;

              span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .t4 {
              @extend .tb-center;
              flex: 1;
            }

            &-header {
              display: flex;
              margin-bottom: 12px;
            }

            &-body {
              max-height: 300px;
              @include product_bo_t2b_color();

              .body-site {
                width: calc(100% - 2px);
                height: 48px;
                @include product_bo_color();
                border-top: 0;
                display: flex;

              }

              .body-site:last-child {
                width: calc(100% - 2px);
                height: 48px;
                @include product_bo_last_color();
                border-top: 0;
                border-bottom: 0;
                display: flex;
              }
            }
          }
        }

        .bottom {
          .bl-title {
            margin: 12px 0;
          }

          .tables-browse {
            .tb-center {
              display: flex;
              align-items: center;
            }

            .t1 {
              @extend .tb-center;
              flex: 1;
            }

            &-body {
              max-height: 250px;
              @include product_bo_t2b_color();

              .body-site {
                width: calc(100% - 2px);
                height: 48px;
                @include product_bo_color();
                border-top: 0;
                display: flex;
              }

              .body-site:last-child {
                width: calc(100% - 2px);
                height: 48px;
                @include product_bo_last_color();
                border-top: 0;
                border-bottom: 0;
                display: flex;
              }
            }
          }
        }
      }
    }
  }

  /deep/ .run-dialog {
    transform: scale(0.8);
    background: rgba(26, 33, 63, 1);
    box-sizing: border-box;

    /deep/ .el-dialog__body {
      padding: 49px 30px 18px;
    }

    .runMap {
      //   height: 897px;
      position: relative;

      .page-box {
        display: flex;
        justify-content: flex-end;
        margin: 10px 0;
      }

      .tables-user {
        min-height: 60px;

        .tb-center {
          display: flex;
          align-items: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .t1 {
          @extend .tb-center;
          width: 80px;
        }

        .t2 {
          @extend .tb-center;
          flex: 1;
        }

        .t3 {
          @extend .tb-center;
          flex: 1;
        }

        .t4 {
          @extend .tb-center;
          flex: 1;
        }

        .t5 {
          @extend .tb-center;
          width: 80px;
        }

        &-header {
          display: flex;
          margin-bottom: 12px;
        }

        &-body {
          max-height: 480px;
          @include product_bo_t2b_color();

          .body-site {
            width: calc(100% - 2px);
            height: 48px;
            @include product_bo_color();
            border-top: 0;
            display: flex;

          }

          .body-site:last-child {
            width: calc(100% - 2px);
            height: 48px;
            @include product_bo_last_color();
            border-top: 0;
            border-bottom: 0;
            display: flex;
          }
        }
      }

      .title {
        font-size: 33px;
        font-weight: 500;
        color: #0269FF;
        text-align: center;
      }

      .form-content {
        margin-top: 40px;

        .el-tabs__item {
          font-size: 20px;
          color: #ffffff;

          &.is-active {
            color: #0269FF;
          }
        }

        .el-tabs__nav-wrap::after {
          background: transparent;
          border-bottom: 2px dashed #2D3040;
        }

        .el-tabs__active-bar {
          background: #0269FF;
        }

        .form-top {
          display: flex;
          justify-content: space-between;
          margin-top: 10px;

          .item {
            width: 361px;
            height: 40px;
          }

          .el-input__inner {
            background: rgba(45, 50, 88, 1);
            border: none;

            &::placeholder {
              color: #8B8C90;
            }
          }

          .el-select__caret {
            color: #8B8C90;
          }
        }

        .form-mid {
          margin-top: 26px;

          .el-textarea__inner {
            background: rgba(45, 50, 88, 1);
            border: none;

            &::placeholder {
              color: #8B8C90;
              font-size: 16px;
            }
          }
        }

        .region-title {
          font-size: 20px;
          margin-top: 30px;

          span:first-child {
            color: #ffffff;
          }

          span:last-child {
            color: #0269FF;
          }
        }

        .map-contain {
          margin-top: 18px;
          width: 100%;
          height: 428px;
        }

        .form-bottom {
          display: flex;
          justify-content: flex-end;
          margin-top: 60px;

          .control {
            display: flex;
            justify-content: flex-end;

            div {
              cursor: pointer;
              width: 80px;
              height: 40px;
              text-align: center;
              font-size: 20px;
              line-height: 40px;
              border-radius: 3px;
              font-size: 20px;
              line-height: 40px;
              box-shadow: 0px 0px 4px 0px #1B2240;
            }

            div:first-child {
              background: #0269FF;
              color: #FFFFFF;
            }

            div:last-child {
              color: #0269FF;
            }
          }
        }
      }
    }
  }

  /deep/ .map-dialog {
    /deep/ .el-dialog__body {
      padding: 0;
    }

    .productMap {
      background-image: url('../../assets/image/product-view-dialog/ditu.png');
      position: relative;
      padding: 0 15px;

      .map-source {
        position: absolute;
        color: #fff;
        bottom: 5px;
        right: 336px;
        z-index: 1000;
        font-size: 12px;
      }

      .top-name {
        height: 60px;
        line-height: 60px;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 800;
        font-style: italic;
        color: #f0ffff;
        display: flex;
        justify-content: space-between;
        align-items: center;
        // text-shadow: 0px 3px 8px rgba(0, 132, 255, 0.88);

        // background: linear-gradient(0deg, #F6FFFF 0%, #DDFFFF 100%);
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }

      .bottom-content {
        display: flex;
        height: 100%;
      }

      .tools-bar {
        position: absolute;
        box-sizing: border-box;
        padding: 20px;
        background-color: rgba(5, 50, 89, 1);
        width: 100%;
        display: flex;
        justify-content: space-between;

        .tools {
          z-index: 600;
          display: flex;
          align-items: center;

          .play-tool {
            font-size: 24px;
            cursor: pointer;
          }
        }

        .full {
          z-index: 600;
          font-size: 24px;
          cursor: pointer;
        }
      }

      .info-title {
        width: 279px;
        height: 30px;
        background-image: url("../../assets/image/product-view-dialog/biaotikuang.png");
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 30px;
        color: #00f0ff;
        padding-left: 36px;
        margin-bottom: 8px;
      }

      .left-info {
        width: 315px;
        height: 100%;

        .overview-info {
          width: 289px;
          height: 316px;
          background-image: url("../../assets/image/product-view-dialog/bg-zuo1.png");
          background-size: 100% 100%;

          padding: 12px 12px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .info-img {
            max-width: 100%;
            max-height: 196px;
            display: block;
            margin: auto;
          }

          .p1 {
            height: 108px;
            font-size: 12px;
            margin: 6px 0;
            color: #CBCED4;
          }
        }

        .mete-data {
          width: 289px;
          height: 173px;
          background-image: url("../../assets/image/product-view-dialog/bg-zuo2.png");
          background-size: 100% 100%;
          padding: 12px;

          .in {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FEFEFE;
            line-height: 18px;
          }

          .tt {
            margin-top: 15px;
            color: #B5FCFF;
            line-height: 18px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
          }
        }

        .related-web {
          width: 291px;
          height: 105px;
          background-image: url("../../assets/image/product-view-dialog/bg-zuo3.png");
          background-size: 100% 100%;
          padding: 12px;

          .info {
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 300;
            color: #CBCED4;
            line-height: 16px;
          }

          .url {
            margin-top: 18px;
            font-size: 12px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #B5FCFF;
            line-height: 18px;
          }
        }
      }

      .center-map {
        flex: 1;
        height: calc(100% - 60px);
        position: relative;
        // visibility: hidden;
        .time-play {
          position: absolute;
          bottom: 16px;
          right: calc(50% + 110px);
          height: 43px;
          display: flex;
          z-index: 7000;

          .t {
            width: 43px;
            height: 43px;
            cursor: pointer;
          }
        }

        .top-tool {
          position: absolute;
          right: 15px;
          top: 12px;
          display: flex;
          z-index: 500;
          overflow: hidden;


          .arrow {
            width: 50px;
            height: 90%;
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
            z-index: 1000;
          }

          .tool-l {
            height: 43px;
            padding-left: 50px;
            padding-right: 28px;
            background-image: url("../../assets/image/product-detail-dialog/tuli-bg1.png");
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 22px;
            text-shadow: 0px 1px 2px rgba(4, 11, 34, 0.1500);
            transition: all 0.5s;
            transform: translateX(0);
            position: relative;

            &.active {
              transform: translateX(94%);
            }
          }

          .tool-r {
            width: auto;
            height: 43px;
            cursor: pointer;
            // background-image: url("../../assets/image/product-detail-dialog/tuli-bg2.png");

            background-image: url("../../assets/image/product-detail-dialog/tuli-bg1.png");
            background-size: 100% 100%;
          }
        }
      }

      .right-info {
        width: 315px;
        height: 100%;

        .Introduction-info {
          width: 291px;
          height: 306px;
          background-image: url("../../assets/image/product-view-dialog/bg-you1.png");
          background-size: 100% 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 12px 12px;

          .info-img {
            max-width: 100%;
            max-height: 196px;
            display: block;
            margin: auto;
          }

          .cc1 {
            height: 96px;
            font-size: 12px;
            color: #CBCED4;
            margin: 3px 0;
          }
        }

        .dynamic-data-analyze {
          width: 289px;
          height: 370px;
          background-image: url("../../assets/image/product-view-dialog/bg-you2.png");
          background-size: 100% 100%;
          padding: 12px 12px;

          .if {
            display: flex;
            justify-content: space-between;
          }
        }

        #rightE2 {
          height: 165px;
          width: 100%;
        }

        .if {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 300;
          color: #FEFEFE;
          line-height: 18px;
        }

        .t-v {
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 300;
          color: #B5FCFF;
          line-height: 18px;
          margin-top: 5px;
        }

        table {
          margin-bottom: 7px;
          width: 100%;
          text-align: center;
          border-collapse: collapse;
          border: 1px solid #00D2FF;

          thead {
            color: #00F2FF;
            background: rgba(0, 217, 255, 0.3);
            border-bottom: 1px solid #00D2FF;
          }

          tbody {
            overflow-y: scroll;
            display: block;
            height: 273px;
            color: #CCE2FF;

            tr {
              table-layout: fixed;
            }
          }

          // td{
          //   white-space: nowrap;
          //   overflow: hidden;
          //   text-overflow: ellipsis;
          // }
        }

        table thead,
        tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;
        }
      }
    }
  }

  // /deep/ .el-dialog__header{
  //   display: none;
  // }
}

/deep/ .map-dialog {
  .el-dialog__header {
    display: none;
  }
}

/deep/ .initSwitchs .el-switch__label span {
  color: white;
}

/deep/ .initSwitchs .is-active span {
  color: rgba(38, 125, 255, 1);
}

/deep/ .initSwitchs2 .el-switch__label span {
  color: white;
}

/deep/ .initSwitchs2 .is-active span {
  color: rgba(38, 125, 255, 1);

}

#product2 {
  width: 100%;
  height: 100%;
}

/deep/ .iclient-leaflet-logo {
  display: none;
}

/deep/ .el-pagination > .btn-next {
  margin-right: 0px;
}

.time-r {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12px;

  .time-site {
    width: 80px;
    height: 20px;
    background-image: url("../../assets/image/product-view-dialog/kuang.png");
    position: relative;

    img {
      width: 8px;
      height: 5px;
    }

    span {
      font-size: 10px;
      color: white;
    }

    .time-picks {
      position: absolute;
      width: 100%;
      height: 20px;
      top: -5px;
      opacity: 0;
    }
  }
}

/deep/ .map-dialog .el-dialog__body {
  padding: 0;
}

/deep/ .time-color {
  .el-input__inner {
    color: black;
  }
}
</style>


